import { GiveawayDetail } from '@bpm-web-app/components/pages';

const GiveawayPage = () => (<GiveawayDetail />);

export default GiveawayPage;
